import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStep5 = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Heart",
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			id: "Path_11636",
			"data-name": "Path 11636",
			d: "M0,0H24V24H0Z",
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_11637",
			"data-name": "Path 11637",
			d: "M7,8h8",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_11638",
			"data-name": "Path 11638",
			d: "M16.884,13.88l-.394.418-.394-.419a2.359,2.359,0,0,0-3.256-.172h0a2.387,2.387,0,0,0-.29,3.305A23.12,23.12,0,0,0,16.49,21a23.319,23.319,0,0,0,4.026-4.094,2.293,2.293,0,0,0-.324-3.153l-.043-.037a2.363,2.363,0,0,0-3.265.165Z",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_11639",
			"data-name": "Path 11639",
			d: "M10,21H5a2,2,0,0,1-2-2V5A2,2,0,0,1,5,3H17a2,2,0,0,1,2,2V9",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		})
	]
});
export default SvgStep5;
